export default __webpack_public_path__ + "static/media/map_pin_varsel_fra_entreprenør.d510c6ee.svg";